import { render, staticRenderFns } from "./PersonDetailEvents.vue?vue&type=template&id=a1e0a17a&"
import script from "./PersonDetailEvents.vue?vue&type=script&lang=js&"
export * from "./PersonDetailEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports